
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import DisplayItem from './DisplayItem.vue'
import rest from '@/rest'
import { MusicServiceLookupItem } from '@/types/music'

interface SearchableItem {
  id: string
  service?: string
  type?: string
  name?: string
  label?: string
  image?: string | null
}

@Component({
  components: { DisplayItem }
})
export default class SpotifyItemSelector extends Vue {
  @Prop({ default: 'Spotify/Apple artist, album or playlist ID' }) inputLabel!: string
  @Prop({ default: 'Add item' }) addButtonText!: string
  @Prop({ default: 'mdi-music' }) defaultIcon!: string
  @Prop({ default: null }) itemType!: string | null // 'artist', 'album', 'playlist', or null for any

  inputId = ''
  currentItem: MusicServiceLookupItem | null = null
  currentItemValid = false

  get getSubtitle () {
    return (item: SearchableItem) => {
      if (item.service && item.type) {
        return `${item.service} ${item.type}`
      }
      if (item.type) {
        return item.type
      }
      return ''
    }
  }

  async searchCurrent () {
    this.currentItem = null
    this.currentItemValid = false
    if (!this.inputId) {
      return
    }

    try {
      const item = await rest.music.findItemFromService(this.inputId)

      // If itemType is specified, validate the type
      if (this.itemType && item.type !== this.itemType) {
        return // Invalid type, don't set current item
      }

      this.currentItem = item
      this.currentItemValid = true
    } catch (error) {
      console.error('Failed to find item:', error)
    }
  }

  @Emit('add')
  addItem (): SearchableItem {
    const itemToAdd = { ...this.currentItem } as SearchableItem
    this.inputId = ''
    this.currentItem = null
    this.currentItemValid = false
    return itemToAdd
  }
}
